import React from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageToggle from '../Common/LanguageToggle';
import { useLanguage } from '../../context/LanguageContext';

function ProfileHeader() {
    const navigate = useNavigate();
    const { t } = useLanguage();

    return (
        <header className="section-t-space">
            <div className="custom-container">
                <div className="profile-header-panel">
                    <button onClick={() => navigate('/')} className="back-btn">
                        <i className="icon" data-feather="arrow-left"></i>
                    </button>
                    <h2>{t('profile')}</h2>
                    <div className="language-toggle-wrapper">
                        <LanguageToggle />
                    </div>
                </div>
            </div>
        </header>
    );
}

export default ProfileHeader;
